<template>
  <div class="inventory">
    <div class="inventory-block">
      <div class="action-label">
        INVENTORY
        <span class="limit" v-if="countItems() > 5">
            [{{ countItems() }}/{{ limitItems() }}]
        </span>
      </div>
      <div class="items">
        <div class="item" v-for="(value, id) in items" v-bind:key="id" v-if="value > 0">
          <div v-on:click="sellItem(id)" v-for="n in value" :class="[ 'icon', 'sm', id ]" :key="id + '-' + n">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Inventory',
  data: () => {
    return {
    }
  },
  methods: {
    sellItem (item) {
      this.$socket.emit('sellItem', {
        item: item
      })
    },
    countItems () {
      return Object.values(this.items)
        .reduce((a, b) => a + b)
    },
    limitItems () {
      return 40
    }
  },
  computed: {
    items: {
      get () {
        var inventoryItems = this.$store.state.player.inventory.items

        var items = {
          water: inventoryItems.water,
          food: inventoryItems.food,
          wood: inventoryItems.wood,
          stone: inventoryItems.stone
        }

        return items
      }
    },
    itemName: () => {
      return {
        food: 'Food',
        water: 'Water',
        wood: 'Wood',
        stone: 'Stone'
      }
    }
  }
}
</script>

<style scoped>

.inventory .limit {
    float: right;
}

/* INVENTORY */
.inventory-block {
    position: fixed;
    bottom: 76px;
    right: 5px;

    display: block;
    width: 208px;
    height: 152px;
    margin: 5px;
    padding: 5px;

    background-color: rgba(0, 0, 0, .2);
    border-radius: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/Inventory.vue